import React from "react";

const EditIcon: React.FC = () => {
  return (
    <svg
      width="19"
      height="17"
      viewBox="0 0 19 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.3396 3.02077H2.81978C2.27084 3.02077 1.74439 3.2168 1.35623 3.56573C0.968066 3.91467 0.75 4.38793 0.75 4.8814V14.9288C0.75 15.4223 0.968066 15.8955 1.35623 16.2445C1.74439 16.5934 2.27084 16.7894 2.81978 16.7894H14.2036C15.342 16.7894 16.2734 15.8591 16.2734 14.8358V7.48628L12.1338 11.3936C11.8233 11.6727 11.4094 11.9518 10.8919 12.0448L8.09773 12.603C6.33842 12.8821 4.68259 11.3936 4.99306 9.71904L5.61399 7.02112C5.71748 6.55596 6.02795 6.09081 6.33842 5.81171L9.44309 2.92773L9.3396 3.02077Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.1358 1.25231C17.9412 0.809173 17.5732 0.445236 17.1009 0.228966C16.7234 0.0800926 16.3049 0.0359786 15.8993 0.102279C15.4936 0.168579 15.1193 0.342272 14.8242 0.601092L14.2032 1.15928L17.2044 3.95023L17.7219 3.39204C17.9227 3.2078 18.081 2.98964 18.1876 2.75013C18.2942 2.51061 18.3469 2.2545 18.3428 1.99656C18.3428 1.8105 18.3428 1.53141 18.1358 1.25231ZM15.6521 5.3457L12.7544 2.55475L7.7869 7.20633L7.68341 7.48542L6.95898 10.2764C6.95898 10.5555 7.26945 10.9276 7.57992 10.8346L10.3741 10.2764L10.6846 10.1833L15.5486 5.53176L15.6521 5.3457Z"
        fill="white"
      />
    </svg>
  );
};

export default EditIcon;
